import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { fmtErr } from "../api";
import InfoTip from "./InfoTip";
import { VEHICLE_LABELS } from "./bits";

export default function FleetSection({ defaultType = "van_small", idPrefix = "vehicle", title = "Vehicles", tip }) {
  const [vehicles, setVehicles] = useState([]);
  const [form, setForm] = useState({ type: defaultType, plate: "", payload_kg: "", pallets: "" });
  const load = () => api.get("/vehicles").then((r) => setVehicles(r.data.vehicles)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <section className="cr-card !p-5" data-testid={`${idPrefix}-section`}>
      <h2 className="text-sm font-bold mb-3 flex items-center">{title}{tip && <InfoTip text={tip} />}</h2>
      {vehicles.map((v) => (
        <div key={v.id} className="flex justify-between items-center py-2 border-b border-[#F6F3EA] text-sm">
          <span>{VEHICLE_LABELS[v.type]} · <span className="font-mono text-xs">{v.plate}</span>{v.pallets ? ` · ${v.pallets} plt` : ""}</span>
          <button data-testid={`${idPrefix}-delete-${v.id}`} onClick={async () => { await api.delete(`/vehicles/${v.id}`); load(); }}
            className="text-xs text-[#A09D95] hover:text-[#1C1B1A] transition-colors">Remove</button>
        </div>
      ))}
      {vehicles.length === 0 && <p className="text-xs text-[#A09D95]">No vehicles yet — add your first one.</p>}
      <div className="grid grid-cols-2 gap-2 mt-4">
        <select data-testid={`${idPrefix}-type`} value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="cr-input">
          {Object.entries(VEHICLE_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
        <input data-testid={`${idPrefix}-plate`} placeholder="Plate" value={form.plate} onChange={(e) => setForm({ ...form, plate: e.target.value })} className="cr-input" />
        <input data-testid={`${idPrefix}-payload`} type="number" placeholder="Payload kg" value={form.payload_kg} onChange={(e) => setForm({ ...form, payload_kg: e.target.value })} className="cr-input" />
        <input data-testid={`${idPrefix}-pallets`} type="number" placeholder="Pallets" value={form.pallets} onChange={(e) => setForm({ ...form, pallets: e.target.value })} className="cr-input" />
      </div>
      <button data-testid={`${idPrefix}-add-btn`} onClick={async () => {
        try {
          await api.post("/vehicles", { ...form, payload_kg: form.payload_kg ? +form.payload_kg : null, pallets: form.pallets ? +form.pallets : null });
          toast.success("Vehicle added");
          setForm({ type: defaultType, plate: "", payload_kg: "", pallets: "" });
          load();
        } catch (e) { toast.error(fmtErr(e)); }
      }} disabled={!form.plate} className="cr-btn-dark mt-3 disabled:opacity-40">Add vehicle</button>
    </section>
  );
}
